import Vue from "vue";
import VueRouter from "vue-router";
import PaddyFieldAdd from "@/components/paddy-field/PaddyFieldAdd.vue";
import PaddyFieldShow from "@/components/paddy-field/PaddyFieldShow.vue";
import WorkHistoryAdd from "@/components/work-history/WorkHistoryAdd.vue";
import WorkHistoryShow from "@/components/work-history/WorkHistoryShow.vue";
import WorkItemDetailEdit from "@/components/work-item/WorkItemDetailEdit.vue";
import WorkItemEdit from "@/components/work-item/WorkItemEdit.vue";
import Work from "../views/Work.vue";
import Weather from "../views/Weather.vue";
import WeatherSettingsAdd from "@/components/settings/WeatherSettingsAdd.vue";
import WeatherSettingsShow from "@/components/settings/WeatherSettingsShow.vue";
// import WaterSettings from "../views/WaterSettings.vue";
// import WaterShow from "@/components/WaterShow.vue";
import ArchivesWorkShow from "@/components/archives/ArchivesWorkShow.vue";
import ArchivesWeatherShow from "@/components/archives/ArchivesWeatherShow.vue";
import ArchivesWaterShow from "@/components/archives/ArchivesWaterShow.vue";
import ArchivesSensorShow from "@/components/archives/ArchivesSensorShow.vue";
import Dashboard from "../views/Dashboard.vue";
import Brand from "../views/Brand.vue";
import BrandDetail from "@/components/BrandDetail.vue";
import BrandOrder from "@/components/BrandOrder.vue";
import MarkerList from "@/components/markers/MarkerList.vue";
import Payment from "../views/Payment.vue";
import PaymentEdit from "../views/PaymentEdit.vue";
import Inquiry from "../views/Inquiry.vue";
import PersonalSettings from "../views/PersonalSettings.vue";
import SignIn from "@/components/authenticator/SignIn.vue";
import SignInPayment from "@/components/authenticator/SignInPayment.vue";
import SignUp from "@/components/authenticator/SignUp.vue";
import ConfirmSignUp from "@/components/authenticator/ConfirmSignUp";
import SignUpComplete from "@/components/authenticator/SignUpComplete";
import ForgotPassword from "@/components/authenticator/ForgotPassword";
import RequireNewPassword from "@/components/authenticator/RequireNewPassword";
import WorkItemOrder from "@/components/work-item/WorkItemOrder.vue";
import WorkOrder from "@/components/work-item/WorkOrder.vue";
import DeleteAccount from "../views/DeleteAccount.vue";
import ArchivesInformationShow from "@/components/archives/ArchivesInformationShow.vue";
import ArchivesLogShow from "@/components/archives/ArchivesLogShow.vue";
import UserList from "../views/UserList.vue";
import Sensor from "../views/Sensor.vue";
import Archive from "../views/Archive.vue";
import UserDetail from "@/components/UserDetail.vue";
// import NotificationSettings from "../views/NotificationSettings.vue";
import LandmarkList from "@/components/markers/LandmarkList.vue";
import ArchivesWorkPaddyShow from "@/components/archives/ArchivesWorkPaddyShow.vue";
import ArchivesWorkNotPaddyShow from "@/components/archives/ArchivesWorkNotPaddyShow.vue";
import SensorShow from "@/components/sensor/SensorShow.vue";
import SensorAdd from "@/components/sensor/SensorAdd.vue";
import SensorSettings from "@/components/sensor/SensorSettings.vue";
import MobileMain from "../views/MobileMain.vue";
import MobilePaymentComplete from "../views/MobilePaymentComplete.vue";
import MobilePaymentEditComplete from "../views/MobilePaymentEditComplete.vue";
import WaterGateShow from "@/components/water-gate/WaterGateShow.vue";
import ArchivesWaterGateShow from "@/components/archives/ArchivesWaterGateShow.vue";
// import Wait from "../views/Wait.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/dashboard",
    alias: "/",
    name: "dashboard",
    components: {
      default: Dashboard,
      auth: SignIn
    }
  },
  {
    path: "/mobile/payment",
    alias: "/mobile",
    name: "mobile-payment",
    components: {
      default: MobileMain,
      auth: SignInPayment
    }
    // component: MobilePayment
  },
  {
    path: "/mobile/payment-new",
    name: "mobile-payment-new",
    components: MobileMain,
  },
  {
    path: "/mobile/payment-edit",
    alias: "/mobile-edit",
    name: "mobile-payment-edit",
    components: {
      default: MobileMain,
      auth: SignInPayment
    }
  },
  {
    path: "/mobile/payment/complete",
    name: "mobile-payment-complete",
    component: MobilePaymentComplete,
    props: true
  },
  {
    path: "/mobile/payment-edit/complete",
    name: "mobile-payment-edit-complete",
    component: MobilePaymentEditComplete,
    props: true
  },
  {
    path: "/work-histories/add",
    name: "work-history-add",
    component: WorkHistoryAdd
  },
  {
    path: "/payment",
    name: "payment",
    component: Payment
  },
  {
    path: "/payment-edit",
    name: "payment-edit",
    component: PaymentEdit
  },
  {
    path: "/work-histories/show",
    name: "work-history-show",
    component: WorkHistoryShow
  },
  {
    path: "/paddy-fields/add",
    name: "paddy-field-add",
    component: PaddyFieldAdd
  },
  {
    path: "/paddy-fields/show",
    name: "paddy-field-show",
    component: PaddyFieldShow
  },
  {
    path: "/water/show",
    name: "water-show",
    component: SensorShow,
    props: true
  },
  {
    path: "/sensor/add",
    name: "sensor-add",
    component: SensorAdd
  },
  {
    path: "/sensor/settings",
    name: "sensor-settings",
    component: SensorSettings
  },
  {
    path: "/weather",
    name: "weather",
    component: Weather
  },
  {
    path: "/weather/settings/show",
    name: "weather-settings-show",
    component: WeatherSettingsShow
  },
  {
    path: "/weather/settings/add",
    name: "weather-settings-add",
    component: WeatherSettingsAdd,
    props: true
  },
  {
    path: "/weather/settings/edit",
    name: "weather-settings-edit",
    component: WeatherSettingsAdd,
    props: true
  },
  // {
  //   path: "/water/settings",
  //   name: "water-settings",
  //   component: WaterSettings
  // },
  {
    path: "/archives",
    name: "archives",
    component: Archive
  },
  {
    path: "/archives/work-histories",
    name: "archives-work",
    component: ArchivesWorkShow,
    props: true
  },
  {
    path: "/archives/work-histories/paddy",
    name: "archives-work-paddy",
    component: ArchivesWorkPaddyShow,
    props: true
  },
  {
    path: "/archives/work-histories/notpaddy",
    name: "archives-work-notpaddy",
    component: ArchivesWorkNotPaddyShow,
    props: true
  },
  {
    path: "/archives/weather-histories",
    name: "archives-weather",
    component: ArchivesWeatherShow,
    props: true
  },
  {
    path: "/archives/water-histories",
    name: "archives-water",
    component: ArchivesSensorShow,
    props: true
  },
  {
    path: "/archives/water-histories/sensor",
    name: "archives-sensor",
    component: ArchivesWaterShow,
    props: true
  },
  {
    path: "/archives/informations",
    name: "archives-information",
    component: ArchivesInformationShow,
    props: true
  },
  {
    path: "/archives/logs",
    name: "archives-log",
    component: ArchivesLogShow,
    props: true
  },
  {
    path: "/archives/water-gate",
    name: "archives-water-gate",
    component: ArchivesWaterGateShow,
    props: true
  },
  {
    path: "/sensors",
    name: "sensors",
    component: Sensor
  },
  {
    path: "/works",
    name: "works",
    component: Work
  },
  {
    path: "/works/item/edit",
    name: "works-item-edit",
    component: WorkItemEdit,
    props: true
  },
  {
    path: "/works/detail/edit",
    name: "works-detail-edit",
    component: WorkItemDetailEdit,
    props: true
  },
  {
    path: "/works/item/order",
    name: "works-item-order",
    component: WorkItemOrder,
    props: true
  },
  {
    path: "/works/order",
    name: "works-order",
    component: WorkOrder,
    props: true
  },
  {
    path: "/users",
    name: "users",
    component: UserList
  },
  {
    path: "/users/detail",
    name: "users-detail",
    props: true,
    component: UserDetail
  },
  // {
  //   path: "/notification/settings",
  //   name: "notification-settings",
  //   props: true,
  //   component: NotificationSettings
  // },
  {
    path: "/brands",
    name: "brands",
    component: Brand
  },
  {
    path: "brands/detail",
    name: "brands-detail",
    component: BrandDetail,
    props: true
  },
  {
    path: "brands/order",
    name: "brands-order",
    component: BrandOrder,
    props: true
  },
  {
    path: "/inquiry",
    name: "inquiry",
    component: Inquiry
  },
  {
    path: "/markers",
    name: "markers",
    component: MarkerList
  },
  {
    path: "/personal-settings",
    name: "personal-settings",
    component: PersonalSettings
  },
  {
    path: "/signup",
    name: "signup",
    components: {
      auth: SignUp
    }
  },
  {
    path: "/confirm-signup",
    name: "confirm-signup",
    components: {
      auth: ConfirmSignUp
    }
  },
  {
    path: "/signup-complete",
    name: "signup-complete",
    components: {
      auth: SignUpComplete
    }
  },
  {
    path: "/forgot",
    name: "forgot",
    components: {
      auth: ForgotPassword
    }
  },
  {
    path: "/input-new-password",
    name: "require-new-password",
    components: {
      auth: RequireNewPassword
    }
  },
  {
    path: "/delete-account",
    name: "delete-account",
    component: DeleteAccount
  },
  {
    path: "/landmarks",
    name: "landmarks",
    component: LandmarkList
  },
  {
    path: "/water-gate/put-show",
    name: "water-gate-put-show",
    component: WaterGateShow
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
